<template>
    <div class="addCompaniesComponent">
        <div v-if="loading" class="text-center">
            <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary"
                indeterminate></v-progress-circular>
        </div>
        <div v-else class="row">
            <div class="formulario col-sm-6 col-md-10">
                <v-form ref="form" lazy-validation class="mt-5 col-sm-10 col-md-6">

                    <v-text-field color="secondary" label="*Comercio" placeholder="Ingrese el comercio"
                        :counter="200" :maxlength="200" required :rules="businessRules"
                        v-model="formData.business"></v-text-field>

                    <v-text-field color=secondary label="*Título" placeholder="Ingrese el título"
                        :counter="100" :maxlength="100" required :rules="titleRules"
                        v-model="formData.title"></v-text-field>

                    <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        color="secondary"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="formattedStartDate"
                            label="*Fecha Inicio del bono"
                            color="secondary"
                            :rules="startDateRules"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="localStartDate"
                        color="primary"
                        @change="handleStartDateChange"
                        ></v-date-picker>
                    </v-menu>

                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        color="secondary"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="formattedEndDate"
                            label="*Fecha Fin del bono"
                            color="secondary"
                            :rules="endDateRules"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker
                        v-model="localEndDate"
                        color="primary"
                        @change="handleEndDateChange"
                        ></v-date-picker>
                    </v-menu>

                    <v-textarea outlined color="secondary" label="*Términos y Condiciones" placeholder="Ingrese los términos y condiciones"
                        :counter="1000" :maxlength="1000" required :rules="termsAndConditionsRules"
                        v-model="formData.termsAndConditions" class="mt-5"></v-textarea>
                </v-form>

                <div class="image-container col-sm-10 col-md-4">
                    <span>Imagen del Comercio</span>
                    <changeImage :image="this.businessImageFile" />
                    <div class="img-btn">
                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs"
                                    v-on="on">
                                    <label for="business-file-input">
                                        <v-icon dark>mdi-plus</v-icon>
                                    </label>
                                </v-btn>
                            </template>
                            <span>Seleccionar una Imagen</span>
                        </v-tooltip>
                        <input type="file" @change="onFileBusiness" id="business-file-input" accept="image/*" style="display: none" />                        
                    </div>
                    <br>
                    <br>
                    <span>Imagen del Bono</span>
                    <div>
                        <changeImage :image="this.bondImageFile" />
                    </div>
                    <div class="img-btn">
                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs"
                                    v-on="on">
                                    <label for="bond-file-input">
                                        <v-icon dark>mdi-plus</v-icon>
                                    </label>
                                </v-btn>
                            </template>
                            <span>Seleccionar una Imagen</span>
                        </v-tooltip>
                        <input type="file" @change="onFileBond" id="bond-file-input" accept="image/*" style="display: none" />                        
                    </div>
                    <br>
                    <br>
                    <span>Imagen del Código del Bono</span>
                    <div>
                        <changeImage :image="this.codeImageFile" />
                    </div>
                    <div class="img-btn">
                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="btn-add-image" fab bottom dark small color="secondary" v-bind="attrs"
                                    v-on="on">
                                    <label for="code-file-input">
                                        <v-icon dark>mdi-plus</v-icon>
                                    </label>
                                </v-btn>
                            </template>
                            <span>Seleccionar una Imagen</span>
                        </v-tooltip>
                        <input type="file" @change="onFileCode" id="code-file-input" accept="image/*" style="display: none" />                        
                    </div>
                </div>    

            </div>
            <v-tooltip left>
                <template v-slot:activator="{ on, attrs }">

                    <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs" v-on="on"
                        @click="submitForm">
                        <v-icon dark>mdi-content-save</v-icon>
                    </v-btn>
                </template>
                <span>Guardar Bono</span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>

import EventBus from '@/utils/event_bus.js';
import { mapActions, mapGetters } from "vuex";
import changeImage from "@/shared/components/change_image/change_image_component.vue";

import {
  BONUS_M,
  GET_STATE_LOADING,
  ACTION_POST_CREATE_BONUS,
} from "@/views/bonus/store/types/types.js";

import Swal from "sweetalert2";
export default {

    components: {
        changeImage,
    },
    name: "addBonusComponent",

    data() {
        return {
            formData: {
                title: null,
                business: null,
                startDate: null,
                endDate: null,
                termsAndConditions: null,
                businessImage: null,
                bondImage: null,
                codeImage: null,
            },
            menu1: false, // Para el date picker de fecha inicio
            menu2: false, // Para el date picker de fecha fin
            localStartDate: null,
            localEndDate: null,
            formattedStartDate: '',
            formattedEndDate: '',
            businessImageFile: null, // Estado local para almacenar la URL de la imagen seleccionada
            bondImageFile: null,
            codeImageFile: null,
            allowedImageTypes: [
                "image/jpeg",
                "image/png",
                "image/jpg",
                "image/svg+xml",
            ],

            businessRules: [
                v => !!v || "Comercio requerido",
                v => (v && v.length <= 200) || "El comercio no puede tener más de 200 caracteres",
            ],
            titleRules: [
                v => !!v || "Título requerido",
                v => (v && v.length <= 100) || "El título no puede tener más de 100 caracteres",
            ],
            startDateRules: [
                v => !!v || 'Fecha Inicio del Bono es requerido',
            ],
            endDateRules: [
                v => !!v || 'Fecha Fin del Bono es requerido',
            ],
            termsAndConditionsRules: [
                v => !!v || "Términos y Condiciones requerido",
                v => (v && v.length <= 1000) || "Los términos y condiciones no pueden tener más de 1000 caracteres",
            ],
            showErrorMessages: false,
        };
    },

    computed: {
        ...mapGetters({
            loading: [`${BONUS_M}${GET_STATE_LOADING}`],
        }),
    },

    methods: {
        ...mapActions({
            postActionCreateBonus: `${BONUS_M}${ACTION_POST_CREATE_BONUS}`,
        }),

        clearForm() {
            this.formData.title = '';
            this.formData.business = '';
            this.formData.startDate = '';
            this.formData.endDate = '';
            this.formData.termsAndConditions = '';
            this.formData.businessImage = '';
            this.formData.bondImage = '';
            this.formData.codeImage = '';
        },

        handleStartDateChange(date) {
            const selectedDate = new Date(`${date}T00:00:00`);
            if (isNaN(selectedDate)) {
                console.error("Invalid date object:", date);
                return;
            }
            
            this.localStartDate = date;
            const modifiedDate = new Date(selectedDate);
            this.formData.startDate = date;
            this.formattedStartDate = date;
            this.validateStartDate(modifiedDate);
            this.menu1 = false;
        },

        validateStartDate(modifiedDate) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const selectedDate = new Date(modifiedDate);
            if (selectedDate < today) {
                Swal.fire({
                icon: "error",
                title: "Fecha no válida",
                text: "La fecha inicial del bono no puede ser anterior a la fecha actual.",
                });
                this.localStartDate = null;
                this.formattedStartDate = "";
                this.formData.startDate = null;
                return;
            }
            
            const anioActual = new Date().getFullYear();
            const anioSeleccionado = modifiedDate.getFullYear();
            if (anioSeleccionado > anioActual) {
                Swal.fire({
                icon: "error",
                title: "Fecha no válida",
                text: "La fecha inicial del bono no puede ser superior al año actual.",
                });
                this.localStartDate = null;
                this.formattedStartDate = "";
                this.formData.startDate = null;
                return;
            }

            if(this.formData.endDate != null){
                if (this.formData.startDate > this.formData.endDate) {
                    Swal.fire({
                    icon: "error",
                    title: "Fecha no válida",
                    text: "La fecha inicial del bono no puede ser superior la fecha final.",
                    });
                    this.localStartDate = null;
                    this.formattedStartDate = "";
                    this.formData.startDate = null;
                    return;
                }
            }
        },

        handleEndDateChange(date) {
            const selectedDate = new Date(`${date}T00:00:00`);
            if (isNaN(selectedDate)) {
                console.error("Invalid date object:", date);
                return;
            }
            this.localEndDate = date;
            const modifiedDate = new Date(selectedDate);
            this.formData.endDate = date;
            this.formattedEndDate = date;
            this.validateEndDate(this.localEndDate, modifiedDate);
            this.menu2 = false;
        },

        validateEndDate(localEndDate, modifiedDate) {
            if (localEndDate < this.localStartDate) {
                Swal.fire({
                icon: "error",
                title: "Fecha no válida",
                text: "La fecha final del bono no puede ser inferior a la fecha inicial.",
                });
                this.localEndDate = null;
                this.formattedEndDate = "";
                this.formData.endDate = null;
                return;
            }
            const anioActual = new Date().getFullYear();
            const anioSeleccionado = modifiedDate.getFullYear();
            if (anioSeleccionado > anioActual) {
                Swal.fire({
                icon: "error",
                title: "Fecha no válida",
                text: "La fecha final del bono no puede ser superior al año actual.",
                });
                this.localEndDate = null;
                this.formattedEndDate = "";
                this.formData.endDate = null;
                return;
            }
        },

        // Método para manejar el cambio de imagen del comercio
        onFileBusiness(event) {
            const file = event.target.files[0];
            if (file) {
                // Asignar el archivo de imagen seleccionado a formData.imageFile
                this.formData.businessImage = file;

                // Leer la URL de la imagen seleccionada y actualizar imageFile si es necesario
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.businessImageFile = e.target.result; // Actualizar la URL de la imagen seleccionada
                };
                reader.readAsDataURL(file);
            }
            if (
                !this.allowedImageTypes.includes(
                    this.formData.businessImage.type
                )
            ) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Por favor ingrese una imagen valida con formato jpg, png, jpeg, svg",
                });
            }
        },

        // Método para manejar el cambio de imagen del bono
        onFileBond(event) {
            const file = event.target.files[0];
            if (file) {
                // Asignar el archivo de imagen seleccionado a formData.imageFile
                this.formData.bondImage = file;

                // Leer la URL de la imagen seleccionada y actualizar imageFile si es necesario
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.bondImageFile = e.target.result; // Actualizar la URL de la imagen seleccionada
                };
                reader.readAsDataURL(file);
            }
            if (
                !this.allowedImageTypes.includes(
                    this.formData.bondImage.type
                )
            ) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Por favor ingrese una imagen valida con formato jpg, png, jpeg, svg",
                });
            }
        },

        // Método para manejar el cambio de imagen del código del bono
        onFileCode(event) {
            const file = event.target.files[0];
            if (file) {
                // Asignar el archivo de imagen seleccionado a formData.imageFile
                this.formData.codeImage = file;

                // Leer la URL de la imagen seleccionada y actualizar imageFile si es necesario
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.codeImageFile = e.target.result; // Actualizar la URL de la imagen seleccionada
                };
                reader.readAsDataURL(file);
            }
            if (
                !this.allowedImageTypes.includes(
                    this.formData.codeImage.type
                )
            ) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Por favor ingrese una imagen valida con formato jpg, png, jpeg, svg",
                });
            }
        },

        async submitForm() {
            try {

                const result = await Swal.fire({
                    title: '¿Desea Guardar?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, guardar',
                    cancelButtonText: 'No',
                    confirmButtonColor: '#6E17A5'
                });
                if (result.isConfirmed) {
                    // Validar el formulario antes de enviarlo
                    const validationErrors = this.validateForm();

                    // Si hay errores de validación, mostrarlos en un único Swal y no enviar el formulario
                    if (Object.keys(validationErrors).length > 0) {
                        const errorMessages = Object.values(validationErrors).join('<br>');
                        Swal.fire({
                            icon: 'error',
                            title: 'Errores de validación',
                            html: '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
                            confirmButtonColor: '#6E17A5'
                        });
                        return;
                    }
                    // Si no hay errores de validación, imprime el formulario en la consola
                    const save = await this.postActionCreateBonus(this.formData);
                    if (!save) {
                        return Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Debes diligenciar los campos'
                        })
                    }
                    await this.clearForm();
                    EventBus.$emit('formBonus-submitted-successfully');
                } else {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'info',
                        title: 'La acción ha sido cancelada.',
                        showConfirmButton: false,
                        timer: 2500
                    });
                }
            } catch (error) {
                console.error("fallo al enviar")
            }
        },

        validateForm() {
            this.showErrorMessages = true;
            const errors = {};

            if (!this.formData.business || !this.formData.business.trim() || this.formData.business.length > 200) {
                errors.business = 'Comercio';
            }

            if (!this.formData.title || !this.formData.title.trim() || this.formData.title.length > 100) {
                errors.title = 'Título';
            }

            if (!this.formData.startDate) {
                errors.startDate = 'Fecha Inicio del Bono';
            }

            if (!this.formData.endDate) {
                errors.endDate = 'Fecha Fin del Bono';
            }

            if (!this.formData.termsAndConditions || !this.formData.termsAndConditions.trim() || this.formData.termsAndConditions.length > 1000) {
                errors.termsAndConditions = 'Términos y Condiciones';
            }

            if (!this.formData.businessImage) {
                errors.businessImage = 'Imagen del Comercio';
            }

            if (!this.formData.bondImage) {
                errors.bondImage = 'Imagen del Bono';
            }

            if (!this.formData.codeImage) {
                errors.codeImage = 'Imagen del Código del Bono';
            }

            return errors;
        },
    },
};

</script>


<style lang="css" scoped>
/* Css input imagen*/

.formulario {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5vw;
}

.row {
    display: flex;
    justify-content: center;
}

.image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.img-btn {
    margin-top: 20px;
}

/*Resposive*/

@media screen and (max-width: 425px) {
    .formulario {
        gap: 10px;
        display: flex;
        flex-direction: column-reverse;
    }
}


/* Para pantallas muy pequeñas */
@media screen and (max-width: 425px) {
    .formulario{
        flex-direction: column;
        align-items: center;
    }

    .image-container {
        margin-bottom: 20px;
    }
}
</style>